import { WifiOff } from 'lucide-react'
import { useOnlineStatus } from '@/hooks/useOnlineStatus'

export function OfflineBanner() {
    const isOnline = useOnlineStatus()

    if (isOnline) return null

    return (
        <div
            className="fixed left-0 right-0 z-[70] flex items-center justify-center gap-2 px-4 bg-amber-500 text-white text-sm font-medium"
            style={{
                top: 0,
                paddingTop: 'max(0.5rem, env(safe-area-inset-top))',
                paddingBottom: '0.5rem',
            }}
        >
            <WifiOff className="w-4 h-4 flex-shrink-0" />
            <span>You're offline. Viewing cached data.</span>
        </div>
    )
}
